export enum NoteCategoryEnum {
  ValidValueName               = 'enumNoteCategory',
  General                      = '00000018-1000-0000-0000-000000000001',
  InitialConsultation          = '00000018-1000-0000-0000-000000000002',
  FinalTreatment               = '00000018-1000-0000-0000-000000000003',
  InterimTreatment             = '00000018-1000-0000-0000-000000000004',
  MultiToothTesting            = '00000018-1000-0000-0000-000000000005',
  CallList                     = '00000018-1000-0000-0000-000000000006',
  DiagnosisPageSummary         = '00000018-1000-0000-0000-000000000007',
  TreatmentPageSummary         = '00000018-1000-0000-0000-000000000008',
  MedicalHistorySummary        = '00000018-1000-0000-0000-000000000009',
  MultiToothSummary            = '00000018-1000-0000-0000-000000000010',
  PainHistorySummary           = '00000018-1000-0000-0000-000000000011',
  ReferringDoctorCommunication = '00000018-1000-0000-0000-000000000012',
  FinancialTickler             = '00000018-1000-0000-0000-000000000013',
  PatientRegistration          = '00000018-1000-0000-0000-000000000014',
  SummaryRecall                = '00000018-1000-0000-0000-000000000015',
  AnesthesiaSummary            = '00000018-1000-0000-0000-000000000016',
  PatientSpecialConsideration  = '00000018-1000-0000-0000-000000000017',
  SurgicalDiagnosis            = '00000018-1000-0000-0000-000000000018',
  SurgicalTreatment            = '00000018-1000-0000-0000-000000000019',
  CBCTSummary                  = '00000018-1000-0000-0000-000000000020',
  XRayMedia                    = '00000018-1000-0000-0000-000000000021',
  Ledger                       = '00000018-1000-0000-0000-000000000022',
  Fee                          = '00000018-1000-0000-0000-000000000023',
  Insurance                    = '00000018-1000-0000-0000-000000000024',
  FinalReport                  = '00000018-1000-0000-0000-000000000025',
  Recall                       = '00000018-1000-0000-0000-000000000026',
  PerioChart                   = '00000018-1000-0000-0000-000000000027',
  TreatmentPlanning            = '00000018-1000-0000-0000-000000000028',
  Treatment                    = '00000018-1000-0000-0000-000000000029',
  Claim                        = '00000018-1000-0000-0000-000000000030',
  EndoDiagnosis                = '00000018-1000-0000-0000-000000000031',
  TreatmentPlanAcceptance      = '00000018-1000-0000-0000-000000000032',
  LedgerVoid                   = '00000018-1000-0000-0000-000000000033',
  OptOutComms                  = '00000018-1000-0000-0000-000000000035',
  OptOutOverwriteComms         = '00000018-1000-0000-0000-000000000036',
  InsuranceCardInfo            = '00000018-1000-0000-0000-000000000037',
  Document                     = '00000018-1000-0000-0000-000000000038'
}
